import { Add, Delete, Edit } from "@mui/icons-material";
import { AlertColor } from "@mui/material";
import {
    GridColDef,
    GridRenderCellParams,
    GridRowParams,
} from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import ButtonGeneric from "../../components/ButtonGeneric";
import { CompleteFilter } from "../../components/CompleteFilter";
import { applyClientFilters } from "../../components/CompleteFilter/applyClientFilters";
import ModalDeleteLeadSource from "../../components/DeleteLeadSourceModal";
import { If } from "../../components/If";
import PageWrapper from "../../components/PageWrapper/index";
import TableDataGrid from "../../components/TableDataGrid";
import Toast from "../../components/Toast";
import { useAuth } from "../../contexts/contexts";
import { api } from "../../services/api";

export interface LeadsSourceProps {
    id: number;
    name: string;
}

function LeadsSourcePage() {
    const [loadingTable, setLoadingTable] = useState(true);
    const [queryFilter, setQueryFilter] = useState("");
    const [dataLeadsSourceList, setDataLeadsSourceList] = useState<
        LeadsSourceProps[]
    >([]);
    const navigate = useNavigate();
    const { hasPermissions, permissions } = useAuth();
    useEffect(() => {
        if (
            hasPermissions("origem.lead.listar") === false &&
            permissions.length > 0
        ) {
            navigate("/Error");
        }
    }, [permissions]);
    const [openDeleteLeadSourceModal, setOpenDeleteLeadSourceModal] =
        useState(false);
    const handleCloseDeleteLeadSourceModal = () => {
        setOpenDeleteLeadSourceModal(false);
    };
    const [selectedRowLeadSource, setSelectedRowLeadSource] = useState("");

    // toast configs
    const [openToast, setOpenToast] = useState(false);
    function handleCloseToast() {
        setOpenToast(false);
    }
    const [toastRequisitionResult, setToastRequisitionResult] =
        useState<AlertColor>();
    const [textToast, setTextToast] = useState("");

    useEffect(() => {
        api.get("leadSource")
            .then((response) => {
                setLoadingTable(false);
                setDataLeadsSourceList(response.data.response);
            })
            .catch((error) => {
                setOpenToast(true);
                setToastRequisitionResult("error");
                setTextToast(error.response.data.message);
            });
    }, []);

    const filteredRows = applyClientFilters(
        dataLeadsSourceList as unknown as Record<string, unknown>[],
        queryFilter,
        { textFields: ["name"] }
    ) as unknown as LeadsSourceProps[];

    const columns: GridColDef[] = [
        { field: "id", headerName: "ID", flex: 5 },
        { field: "name", headerName: "Leads", flex: 20 },
        {
            field: "ações",
            headerName: "Ações",
            flex: 25,
            sortable: false,
            align: "right",
            headerAlign: "right",
            disableExport: true,
            renderCell: (params: GridRenderCellParams) => (
                <div className="containerActionButtonsListTablePagesGlobal">
                    <If condition={hasPermissions("origem.lead.editar")}>
                        <Edit
                            className="cursorPointerGlobal"
                            onClick={() => {
                                navigate(
                                    `/settings/leadsSource/leadSourceEdit?id=${params.id}`
                                );
                            }}
                        />
                    </If>
                    <If condition={hasPermissions("origem.lead.excluir")}>
                        <Delete
                            className="cursorPointerGlobal"
                            onClick={() => {
                                setOpenDeleteLeadSourceModal(true);
                            }}
                        />
                    </If>
                </div>
            ),
        },
    ];

    return (
        <>
            <PageWrapper>
                <div className="containerListTablePagesGlobal">
                    <CompleteFilter
                        fields={[{ value: "name", label: "Leads" }]}
                        onSearch={setQueryFilter}
                        actions={
                            <If
                                condition={hasPermissions(
                                    "origem.lead.cadastrar"
                                )}
                            >
                                <ButtonGeneric
                                    onclick={() => {
                                        navigate(
                                            "/settings/leadsSource/leadSourceRegister"
                                        );
                                    }}
                                    buttonColor="var(--primary)"
                                    text="Nova Origem de Lead"
                                    icon={<Add />}
                                />
                            </If>
                        }
                    />
                    <TableDataGrid
                        rows={filteredRows}
                        columns={columns}
                        onRowClick={(rowParams: GridRowParams) => {
                            setSelectedRowLeadSource(rowParams.row);
                        }}
                        loading={loadingTable}
                    />
                    <ModalDeleteLeadSource
                        openDeleteLeadSourceModal={openDeleteLeadSourceModal}
                        handleCloseDeleteLeadSourceModal={
                            handleCloseDeleteLeadSourceModal
                        }
                        selectedRowLeadSource={selectedRowLeadSource}
                        dataLeadsSourceList={dataLeadsSourceList}
                        setDataLeadsSourceList={setDataLeadsSourceList}
                    />
                </div>
            </PageWrapper>
            <Toast
                open={openToast}
                onClose={() => handleCloseToast()}
                severity={toastRequisitionResult}
                text={textToast}
            />
        </>
    );
}
export default LeadsSourcePage;
